import { render, staticRenderFns } from "./BuscadorMenu.vue?vue&type=template&id=2c5b1106&"
import script from "./BuscadorMenu.vue?vue&type=script&lang=js&"
export * from "./BuscadorMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports